import { render } from "./ModalSubtotal.vue?vue&type=template&id=f457344e"
import script from "./ModalSubtotal.vue?vue&type=script&lang=js"
export * from "./ModalSubtotal.vue?vue&type=script&lang=js"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__